<nav class="new-custom-route__nav">
  <ul class="nav__items">
    @for ( item of navItems; track item.value ) {
      <li 
        class="nav__item"
        (click)="handleNavItemClick(item.value)"
      >
        <app-nav-button 
          [label]="item.label | translate"
          [iconName]="item.iconName"
          [active]="mobileViewsState === item.value"
        />
      </li>
    }
  </ul>
</nav>